import { getCompanyId, getUserId } from 'data/storage';
import type { PointHubReportContext, PointHubUserCandidate, PointHubUserInfo } from './types';

const firstNonEmpty = (...values: Array<unknown>): string | undefined => {
  for (let index = 0; index < values.length; index += 1) {
    const value = values[index];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return undefined;
};

const getCandidate = (context?: PointHubReportContext): PointHubUserCandidate | null => {
  if (!context) return null;
  try {
    return context.getUser ? context.getUser() || null : context.user || null;
  } catch (_error) {
    return null;
  }
};

export const resolvePointHubUserInfo = (context?: PointHubReportContext): PointHubUserInfo | null => {
  if (context && context.resolvedUserInfo) return context.resolvedUserInfo;
  const candidate = getCandidate(context) || {};
  const userId = firstNonEmpty(getUserId(), candidate.userId, candidate.id, candidate._id);
  const userName = firstNonEmpty(
    candidate.realName,
    candidate.realname,
    candidate.name,
    candidate.displayName,
    candidate.nickName
  );
  const orgId = firstNonEmpty(getCompanyId(), candidate.companyId, candidate.orgId);
  const orgName = firstNonEmpty(
    candidate.companyName,
    candidate.customCompanyName,
    candidate.orgName,
    candidate.company
  );

  if (!userId || !userName || !orgId || !orgName) return null;
  return { userId, userName, orgId, orgName };
};

export const getPointHubUserIdentityKey = (userInfo: PointHubUserInfo): string => {
  return `${userInfo.userId}|${userInfo.orgId}`;
};
